import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_ROOMS = "GET_ALL_ROOMS";
export const GET_ROOM = "GET_ROOM";
export const GET_ROOM_BY_LOCATION = "GET_ROOM_BY_LOCATION";
export const CAR_LOADING = "CAR_LOADING";
export const ADD_ROOM = "ADD_ROOM";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllRooms = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAR_LOADING
    });
    await instance.get(`/Rooms/GetAllRooms/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_ROOMS,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetRoomById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAR_LOADING
    });
    await instance.get(`/Rooms/GetRoomsById/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_ROOM,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};
export const GetRoomByLocation = (loc_id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAR_LOADING
    });
    await instance.get(`/Rooms/GetLocationByRoom/${loc_id}&${Token}`).then((res => {
        dispatch({
            type: GET_ROOM_BY_LOCATION,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};
export const addRoom = data =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: CAR_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/Rooms/PutInsUpdtRoom/${data.id}&${data.loc_id}&${data.name}&${data.active}&${data.virtual}&${data.modified_By}&${Token}` ).then((res => {
            dispatch({
                type: ADD_ROOM,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
